import classnames from 'classnames';
import React from 'react';
import { formatTimeForDisplay } from 'utils/timeHelpers/formatTimeForDisplay';

const CSS = require('./TimeSlot.module.scss');

function TimeSlot({
  time,
  onTimeChange,
  isSelected,
  isPreferredLocalAvailable,
  disabled,
}) {
  const onClick = () => onTimeChange(time);

  return (
    <li key={time} className={CSS.TimeSlot}>
      <button
        onClick={onClick}
        className={classnames(CSS.TimeSlotButton, {
          [CSS.PrefferedTimeSlot]: isPreferredLocalAvailable,
        })}
        data-variant={isSelected && 'selected'}
        disabled={disabled}
        title={disabled ? 'Local is not available on this time' : ''}
        data-time={time}
      >
        <span className={CSS.Time}>{formatTimeForDisplay(time)}</span>
      </button>
    </li>
  );
}

export default TimeSlot;
